var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.88209 7.11648C6.89609 7.13006 6.91399 7.14104 6.93442 7.1486C6.95485 7.15615 6.97727 7.16008 7 7.16008C7.02273 7.16008 7.04515 7.15615 7.06558 7.1486C7.08601 7.14104 7.10391 7.13006 7.11791 7.11648L9.21417 5.10369C9.29091 5.02983 9.22166 4.92045 9.09626 4.92045H7.70936V0.113636C7.70936 0.0511364 7.64198 0 7.55963 0H6.43663C6.35428 0 6.2869 0.0511364 6.2869 0.113636V4.91903H4.90374C4.77834 4.91903 4.70909 5.02841 4.78583 5.10227L6.88209 7.11648ZM13.8503 6.61932H12.7273C12.6449 6.61932 12.5775 6.67045 12.5775 6.73295V8.92045H1.42246V6.73295C1.42246 6.67045 1.35508 6.61932 1.27273 6.61932H0.149733C0.0673797 6.61932 0 6.67045 0 6.73295V9.54545C0 9.79688 0.267647 10 0.59893 10H13.4011C13.7324 10 14 9.79688 14 9.54545V6.73295C14 6.67045 13.9326 6.61932 13.8503 6.61932Z",
    fill: "#8a8a8b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.1a603265991b30a70dc24b2dfc15b894.svg";
export { ForwardRef as ReactComponent };